import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * One spinner for the whole app.
 *
 * Default: inline centred spinner sized for a button/form area.
 * fullscreen: dimmed overlay over the viewport, use during page-level
 *             async work (login submit, build upload).
 */
const Spinner = ({ fullscreen = false, size = 40, label }) => {
    if (fullscreen) {
        return (
            <Box
                role="status"
                aria-live="polite"
                aria-label={label || 'Loading'}
                sx={{
                    position: 'fixed',
                    inset: 0,
                    zIndex: (t) => t.zIndex.modal + 10,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1.5,
                    backgroundColor: 'rgba(255, 251, 241, 0.72)',
                    backdropFilter: 'blur(4px)',
                }}
            >
                <CircularProgress color="primary" size={size} thickness={4} />
                {label && (
                    <Box sx={{ color: 'text.secondary', fontWeight: 600 }}>{label}</Box>
                )}
            </Box>
        );
    }

    return (
        <Box
            role="status"
            aria-live="polite"
            aria-label={label || 'Loading'}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                py: 1.5,
            }}
        >
            <CircularProgress color="primary" size={size} thickness={4} />
            {label && (
                <Box sx={{ color: 'text.secondary', fontWeight: 600 }}>{label}</Box>
            )}
        </Box>
    );
};

export default Spinner;
